import { render, staticRenderFns } from "./SchedulingButtons.vue?vue&type=template&id=42d046dc&"
import script from "./SchedulingButtons.vue?vue&type=script&lang=js&"
export * from "./SchedulingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlatformIcon: require('/Users/grant/Dev/postpone/frontend/components/platform/Icon.vue').default,ButtonDropdown: require('/Users/grant/Dev/postpone/frontend/components/ButtonDropdown.vue').default})
